import { render } from "./FormFileDropzone.vue?vue&type=template&id=310938d7&lang=pug"
import script from "./FormFileDropzone.vue?vue&type=script&lang=js"
export * from "./FormFileDropzone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__